export const map = <TKey extends string, TValue>(
  key: TKey,
  values: Record<TKey, TValue>,
): TValue => {
  return values[key];
};
